import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { Loading } from "@rentiohq/web-shared/dist/components";
import { Navigate, Outlet } from "react-router-dom";

// The menu entry only shows for an office with Rentmatch, but a route is
// reachable by URL as well, so the academy checks the feature itself.
export const AcademyRoute = () => {
  // Not useBrokerFeature: that reports "no feature" while the office record is
  // still on its way, which on a page opened from the address bar it always is.
  const { isFetchingBroker, hasFeature } = brokerHooks.useBrokerFeatureLoader(
    EBrokerFeature.RentMatch,
  );

  if (isFetchingBroker) {
    return <Loading />;
  }

  if (!hasFeature) {
    return <Navigate to="/" replace={true} />;
  }

  return <Outlet />;
};
